import {
    INVENTORY_POPULATE,
} from '../../constants/types';

import moment from 'moment';


export const INITIAL_STATE = {
  'sale_grn_inventory':{

    title: {
        text: ''
    },

    subtitle: {
        text: ''
    },

    yAxis: {
        title: {
            text: ''
        }
    },
    legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle'
    },

    plotOptions: {
        series: {
            label: {
                connectorAllowed: false
            },
            pointStart: 2010
        }
    },

    series: [
      {
        name: '',
        data: [],
        color: {
          "linearGradient": {
            "x2": 0,
            "y1": 0,
            "x1": 0,
            "y2": 1
          },
          "stops": [
            [
              0,
              "#fdc2a4"
            ],
            [
              1,
              "#f895cc"
            ]
          ]
        },
        
      }, {
          name: '',
          data: []
      }
    ],

    responsive: {
        rules: [{
            condition: {
                maxWidth: 500
            },
            chartOptions: {
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                }
            }
        }]
    }

  },
  "pos_chart": {
    "series": [
      {
        "name": "Value of PO's",
        "yAxis": 1,
        "color": {
          "linearGradient": {
            "x2": 0,
            "y1": 0,
            "x1": 0,
            "y2": 1
          },
          "stops": [
            [
              0,
              "#fdc2a4"
            ],
            [
              1,
              "#f895cc"
            ]
          ]
        },
        "type": "column",
        "data": [],
        "showInLegend": true
      },
      {
        "name": "# of PO's",
        "yAxis": 0,
        "color": {
          "linearGradient": {
            "x2": 0,
            "y1": 0,
            "x1": 0,
            "y2": 1
          },
          "stops": [
            [
              0,
              "#c9bded"
            ],
            [
              1,
              "#898afe"
            ]
          ]
        },
        "type": "column",
        "data": [],
        "showInLegend": true
      }
    ],
    "categories": [
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat",
      "Sun"
    ]
  },
  "grns_chart": {
    "series": [
      {
        "name": "Value of GRNS",
        "yAxis": 1,
        "color": {
          "linearGradient": {
            "x2": 0,
            "y1": 0,
            "x1": 0,
            "y2": 1
          },
          "stops": [
            [
              0,
              "#fd219d"
            ],
            [
              1,
              "#f8616a"
            ]
          ]
        },
        "type": "column",
        "data": [],
        "showInLegend": true
      },
      {
        "name": "# of GRNS",
        "yAxis": 0,
        "color": {
          "linearGradient": {
            "x2": 0,
            "y1": 0,
            "x1": 0,
            "y2": 1
          },
          "stops": [
            [
              0,
              "#ffe131"
            ],
            [
              1,
              "#ffae40"
            ]
          ]
        },
        "type": "column",
        "data": [],
        "showInLegend": true
      }
    ],
    "categories": [
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat",
      "Sun"
    ]
  },
  "invoices_chart": {
    "series": [
      {
        "name": "Value of Invoices",
        "yAxis": 1,
        "color": {
          "linearGradient": {
            "x2": 0,
            "y1": 0,
            "x1": 0,
            "y2": 1
          },
          "stops": [
            [
              0,
              "#fee332"
            ],
            [
              1,
              "#fead41"
            ]
          ]
        },
        "type": "column",
        "data": [],
        "showInLegend": true
      },
      {
        "name": "# of invoices",
        "yAxis": 0,
        "color": {
          "linearGradient": {
            "x2": 0,
            "y1": 0,
            "x1": 0,
            "y2": 1
          },
          "stops": [
            [
              0,
              "#6fddb6"
            ],
            [
              1,
              "#52baef"
            ]
          ]
        },
        "type": "column",
        "data": [],
        "showInLegend": true
      }
    ],
    "categories": [
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat",
      "Sun"
    ]
  },
  "locations": [
  {
  "header":"locations",
    "chart": {
        "series": [
          {
            "name": "location_name",
            "yAxis": 1,
            "color": {
              "linearGradient": {
                "x2": 0,
                "y1": 0,
                "x1": 0,
                "y2": 1
              },
              "stops": [
                [
                  0,
                  "#fdc2a4"
                ],
                [
                  1,
                  "#f895cc"
                ]
              ]
            },
            "type": "column",
            "data": [],
            "showInLegend": true
          },
        ],
        "categories": [
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat",
          "Sun"
          ]
        }
      }
    ],
  "inventory_value": {
    "header": "Inventory Value",
    "original_value": 0,
    "value": "Rs. ",
    "data": {
      
    },
    "text": ""
  },
  "gross_margin": {
    "header": "Gross Margin",
    "original_value": 0,
    "value": "Rs. ",
    "data": {
      
    },
    "text": ""
  },
  "beginning_qty": {
    "header": "Beginning Qty",
    "original_value": 0,
    "value": "Rs. ",
    "data": {
      
    },
    "text": ""
  },
  "beginning_value": {
    "header": "Beginning Value",
    "original_value": 0,
    "value": "Rs. ",
    "data": {
      
    },
    "text": ""
  },
  "inventory_qty": {
    "header": "Inventory Qty",
    "original_value": 0,
    "value": "Rs. ",
    "data": {
      
    },
    "text": ""
  },
  "total_cogs": {
    "header": "Total Cogs",
    "original_value": 0,
    "value": "Rs. ",
    "data": {
      
    },
    "text": ""
  },
  "gmroi": {
    "header": "GMROI",
    "original_value": 0,
    "value": "Rs. ",
    "data": {
      
    },
    "text": ""
  },
  "turns": {
    "header": "Turns",
    "original_value": 0,
    "value": "Rs. ",
    "data": {
      
    },
    "text": ""
  },
  "dusty_inventory": {
    "header": "Dusty Inventory",
    "original_value": 0,
    "value": "0%",
    "data": {
      
    },
    "text": ""
  },
  "low_stock": {
    "header": "Low Stock Alerts",
    "original_value": 0,
    "value": "0",
    "data": {
      
    },
    "text": ""
  },
  "low_stock_items": {
    "header": "LOW STOCK ITEMS",
    "keys": [
      "name",
      "value",
      "inventory_percentage"
    ],
    "data": {
      "headers": [
        "",
        "Current",
        "Change",
        "Current",
        "Change",
        "Current"
      ],
      "topHeaders": [
        "PRODUCT",
        "VALUE",
        "% OF INVENTORY"
      ],
      "values": []
    }
  },
  "dead_stock_items": {
    "header": "DEAD STOCK ITEMS",
    "keys": [
      "name",
      "qty",
      "value",
      "days_to_zero",
      "contribution_of_sales"
    ],
    "data": {
      "headers": [
        "",
        "Current",
        "Change",
        "Current",
        "Change",
        "Current"
      ],
      "topHeaders": [
        "PRODUCT",
        "QTY",
        "VALUE",
        "DAYS TO ZERO",
        "CONTRIBUTION OF SALES"
      ],
      "values": []
    }
  },
  "inventory_by_categories": {
    "header": "INVENTORY BY CATEGORIES",
    "keys": [
      "name",
      "value",
      "inventory_percentage",
    ],
    "data": {
      "headers": [
        "",
        "Current",
        "Change",
        "Current",
        "Change",
        "Current"
      ],
      "topHeaders": [
        "TOP LEVEL CATEGORY",
        "VALUE",
        "% OF INVENTORY",
      ],
      "values": []
    }
  },
  "inventory_by_sub_categories": {
    "header": "INVENTORY BY TOP SUB CATEGORIES",
    "keys": [
      "name",
      "value",
      "inventory_percentage"
    ],
    "data": {
      "headers": [
        "",
        "Current",
        "Change",
        "Current",
        "Change",
        "Current"
      ],
      "topHeaders": [
        "TOP LEVEL CATEGORY",
        "VALUE",
        "% OF INVENTORY"
      ],
      "values": []
    }
  },
  "inventory_by_top_selling": {
    "header": "INVENTORY BY TOP SELLING PRODUCTS",
    "keys": [
      "name",
      "value",
      "inventory_percentage"
    ],
    "data": {
      "headers": [
        "",
        "Current",
        "Change",
        "Current",
        "Change",
        "Current"
      ],
      "topHeaders": [
        "PRODUCTS",
        "VALUE",
        "% OF INVENTORY"
      ],
      "values": []
    }
  },
  "inventory_by_low_selling": {
    "header": "INVENTORY BY LOW SELLING PRODUCTS",
    "keys": [
      "name",
      "value",
      "inventory_percentage"
    ],
    "data": {
      "headers": [
        "",
        "Current",
        "Change",
        "Current",
        "Change",
        "Current"
      ],
      "topHeaders": [
        "PRODUCTS",
        "VALUE",
        "% OF INVENTORY"
      ],
      "values": []
    }
  },
  "inventory_by_manufacturer": {
    "header": "INVENTORY BY LOW SELLING PRODUCTS",
    "keys": [
      "name",
      "value",
      "inventory_percentage"
    ],
    "data": {
      "headers": [
        "",
        "Current",
        "Change",
        "Current",
        "Change",
        "Current"
      ],
      "topHeaders": [
        "MANUFACTURE",
        "VALUE",
        "% OF INVENTORY"
      ],
      "values": []
    }
  }
}
export const Reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INVENTORY_POPULATE:
            return { ...state, ...action.payload };
        default:
            return state
    }
}




// WEBPACK FOOTER //
// ./src/modules/inventory/InventoryReducer.js